import "core-js/modules/es.promise.js";
import axios from 'axios';
import { cleanJwt, promiseJwt } from "./auth-jwt.utils";
import { refreshTokenItem } from "./auth-base.vm";
export const refreshJwt = () => new Promise((resolve, reject) => {
  promiseJwt(() => {
    const token = localStorage.getItem(refreshTokenItem);
    return axios.get('/api/public/user/refresh/token', {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }).then(res => resolve(res)).catch(e => {
    cleanJwt();
    reject(e);
  });
});
export const baseLogin = form => promiseJwt(() => {
  var _form$bu;
  return axios.post(`/api/public/user/login`, {
    username: form.username,
    password: form.password,
    businessUnit: (_form$bu = form.bu) !== null && _form$bu !== void 0 ? _form$bu : 'SHARE'
  });
});
export const baseAutoLogin = form => promiseJwt(() => axios.get(`/api/public/user/auto/login?p=${encodeURIComponent(form.p)}&bu=${encodeURIComponent(form.bu)}`));
export const baseExternalAutoLogin = form => promiseJwt(() => axios.get(`/api/public/user/auto/login/external?p=${encodeURIComponent(form.p)}&bu=${encodeURIComponent(form.bu)}`));
export const baseF2aAutoLogin = form => axios.post(`/api/public/user/auto/f2a`, {
  buCode: form.bu,
  p: form.p
});
export const baseOnlyPwdLogin = form => axios.post(`/api/public/user/login/onlyPassword`, {
  buCode: form.bu,
  p: form.p
});

// f2a related

export const requestF2aOtp = form => axios.post(`/api/public/user/f2a/request/${form.channel}`, {
  buCode: form.bu,
  username: form.username,
  chars: form.chars
});
export const verifyF2aOtp = form => promiseJwt(() => axios.post(`/api/public/user/f2a/otp/verify`, {
  buCode: form.bu,
  username: form.username,
  otp: form.otp
}));

// pwd related

export const checkPassword = form => promiseJwt(() => {
  var _form$bu2;
  return axios.post(`/api/public/user/check/pwd`, {
    username: form.username,
    password: form.password,
    businessUnit: (_form$bu2 = form.bu) !== null && _form$bu2 !== void 0 ? _form$bu2 : 'SHARE',
    lastPassword: form.lastPassword,
    repeatPassword: form.repeatPassword
  });
});
export const requestRestorePassword = form => axios.get(`/api/public/user/recover/password?username=${encodeURIComponent(form.username)}&businessUnit=${encodeURIComponent(form.bu)}`);
export const restorePassword = form => promiseJwt(() => {
  var _form$bu3;
  return axios.post(`/api/public/user/recover/password?bc=${encodeURIComponent(form.bc)}`, {
    username: form.username,
    password: form.password,
    passwordRepeat: form.confirmed,
    buCode: (_form$bu3 = form.bu) !== null && _form$bu3 !== void 0 ? _form$bu3 : 'SHARE'
  });
});

// logout

export const logout = () => new Promise((resolve, reject) => {
  axios.get('/api/public/user/logout').then(res => {
    cleanJwt();
    resolve(res);
  }).catch(e => reject(e));
});